import { createFileRoute } from '@tanstack/react-router';

import { NotFound } from '~/components/common/not-found/not-found';

/** Catch-all for any authenticated path with no matching route — renders 404 inside the shell. */
export const Route = createFileRoute('/_authenticated/$')({
  component: NotFound,
});
